export const jeeMainsAdvanceReservationQuotas = [
  "EWS_GIRLS_HS",
  "EWS (PwD)_AI",
  "EWS (PwD)_GIRLS_AI",
  "EWS (PwD)_GIRLS_HS",
  "EWS (PwD)_GIRLS_OS",
  "EWS (PwD)_HS",
  "EWS (PwD)_OS",
  "EWS_AI",
  "EWS_HS",
  "EWS_OS",
  "OBC-NCL (PwD)_HS",
  "OBC-NCL (PwD)_OS",
  "OBC-NCL_GIRLS_HS",
  "OBC-NCL_GIRLS_OS",
  "OBC-NCL_HS",
  "EWS_GIRLS_AI",
  "OBC-NCL_OS",
  "EWS_GIRLS_GO",
  "OPEN (PwD)_HS",
  "OPEN (PwD)_OS",
  "EWS_GIRLS_JK",
  "EWS_GIRLS_OS",
  "OPEN_GIRLS_HS",
  "EWS_GO",
  "OPEN_GIRLS_OS",
  "OPEN_HS",
  "EWS_JK",
  "OPEN_OS",
  "SC_GIRLS_HS",
  "OBC-NCL (PwD)_AI",
  "SC_GIRLS_OS",
  "SC_HS",
  "SC_OS",
  "OBC-NCL (PwD)_GIRLS_AI",
  "OBC-NCL (PwD)_GIRLS_HS",
  "OBC-NCL (PwD)_GIRLS_OS",
  "ST_GIRLS_HS",
  "ST_GIRLS_OS",
  "OBC-NCL_AI",
  "ST_HS",
  "ST_OS",
  "OBC-NCL_GIRLS_AI",
  "OBC-NCL_GIRLS_GO",
  "OBC-NCL_GIRLS_JK",
  "OBC-NCL_GO",
  "OBC-NCL_JK",
  "OPEN (PwD)_AI",
  "OPEN_AI",
  "OPEN_GIRLS_AI",
  "SC_AI",
  "ST_AI",
  "OPEN (PwD)_GIRLS_AI",
  "OPEN (PwD)_GIRLS_HS",
  "OPEN (PwD)_GIRLS_OS",
  "OPEN (PwD)_JK",
  "SC_GIRLS_AI",
  "ST_GIRLS_AI",
  "OPEN_GIRLS_GO",
  "OPEN_LA",
  "OPEN_GIRLS_JK",
  "OPEN_GIRLS_LA",
  "OPEN_GO",
  "OPEN_JK",
  "SC (PwD)_AI",
  "SC (PwD)_GIRLS_HS",
  "SC (PwD)_GIRLS_OS",
  "SC (PwD)_HS",
  "SC (PwD)_OS",
  "SC_GIRLS_GO",
  "SC_GIRLS_JK",
  "SC_GO",
  "SC_JK",
  "ST (PwD)_AI",
  "ST (PwD)_GIRLS_OS",
  "ST (PwD)_HS",
  "ST (PwD)_OS",
  "ST_GIRLS_JK",
  "ST_GIRLS_LA",
  "ST_GO",
  "ST_JK"
];

export const wbjeeMainsAdvanceReservationQuotas = [
  'OPEN_AI',
  'OPEN_HS',
  'OBC_A_AI',
  'OBC_A_HS',
  'SC_AI',
  'SC_HS',
  'ST_AI',
  'ST_HS',
  'TUITION_FEE_WAIVER_AI',
  'TUITION_FEE_WAIVER_HS',
  'OBC_B_AI',
  'OBC_B_HS',
  'OPEN_PWD_AI',
  'OPEN_PWD_HS',
  'OBC_A_PWD_AI',
  'OBC_A_PWD_HS',
  'SC_PWD_AI',
  'SC_PWD_HS',
  'OBC_B_PWD_AI',
  'OBC_B_PWD_HS',
  'EWS_AI',
  'EWS_HS',
];

export const mhtcetReservationQuotas = [
  "GNT2H_I",
  "GOBCH_I",
  "GOPENH_I",
  "GSCH_I",
  "GSEBCH_I",
  "GSTH_I",
  "GSTH_VII",
  "LOBCH_I",
  "LOPENH_I",
  "LSEBCH_VII",
  "PWDOPENH_I-Non PWD",
  "GSEBCH_VII",
  "LSCH_I",
  "GVJH_I",
  "LNT1H_I",
  "LSTH_I",
  "LSTH_II",
  "LVJH_I",
  "PWDOBCH_I-Non PWD",
  "PWDOPENH_I",
  "GNT1H_I",
  "LNT3H_I",
  "LSEBCH_I",
  "PWDOBCH_I",
  "GNT3H_I",
  "LNT2H_I",
  "LSTH_VII",
  "PWDROBC_I",
  "PWDSCH_I-Non PWD",
  "LVJH_II",
  "GVJH_VII",
  "LNT3H_II",
  "PWDSEBCH_VII",
  "LSCH_II",
  "LVJH_VII",
  "LOBCH_II",
  "GSCH_VII",
  "LOPENH_II",
  "LSEBCH_II",
  "GOBCH_VII",
  "LOPENH_VII",
  "LSCH_VII",
  "LNT2H_II",
  "PWDSEBCH_I-Non PWD",
  "LOBCH_VII",
  "PWDOBCH_VII",
  "LNT1H_II",
  "PWDSCH_I",
  "PWDSCH_VII",
  "PWDRSCH_I",
  "PWDRSTH_I",
  "PWDRSEBC_I",
  "GSEBCO_I",
  "GVJO_I",
  "LSTO_II",
  "GSTO_I",
  "LSCO_I",
  "GOBCO_I",
  "LOPENO_I",
  "GNT1O_I",
  "GOPENO_I",
  "GSCO_I",
  "GSTO_VII",
  "LSEBCO_VII",
  "LSTO_I",
  "LVJO_I",
  "GNT2O_I",
  "GSEBCO_VII",
  "LNT2O_I",
  "LOBCO_I",
  "LSTO_VII",
  "LSEBCO_I",
  "LSCO_II",
  "GNT3O_I",
  "LSCO_VII",
  "LNT1O_I",
  "LVJO_II",
  "LOBCO_II",
  "LNT3O_I",
  "LVJO_VII",
  "LSEBCO_II",
  "GSCO_VII",
  "GOBCO_VII",
  "LOPENO_II",
  "LNT2O_II",
  "LOBCO_VII",
  "LNT3O_II",
  "LNT1O_II",
  "GVJO_VII",
  "LOPENO_VII",
  "DEFOBCS_I",
  "DEFOPENS_I",
  "DEFRSEBC_I",
  "EWS_I",
  "GNT1S_I",
  "GNT2S_I",
  "GNT3S_I",
  "GOBCS_I",
  "GOPENS_I",
  "GSCS_I",
  "GSEBCS_I",
  "GSTS_I",
  "GVJS_I",
  "LNT2S_I",
  "LOBCS_I",
  "LOPENS_I",
  "LSCS_I",
  "LSEBCS_I",
  "LSTS_I",
  "LVJS_I",
  "ORPHAN_VII",
  "PWDOBCS_I",
  "PWDOPENS_I",
  "PWDOPENS_I-Non PWD",
  "TFWS_I",
  "DEFROBCS_I",
  "LNT1S_I",
  "LNT3S_I",
  "ORPHAN_I",
  "PWDRSCS_I",
  "PWDOBCS_I-Non PWD",
  "LSTS_II",
  "DEFRNT1S_I",
  "DEFOPENS_I-Non Defence",
  "DEFRSCS_I",
  "LSEBCS_II",
  "DEFOBCS_I-Non Defence",
  "DEFSCS_I-Non Defence",
  "DEFSEBCS_I-Non Defence",
  "GSTS_VII",
  "LSTS_VII",
  "PWDSCS_I-Non PWD",
  "DEFSEBCS_VII",
  "GSEBCS_VII",
  "LNT3S_II",
  "LSEBCS_VII",
  "PWDSEBCS_I-Non PWD",
  "PWDSEBCS_VII",
  "DEFSCS_I",
  "PWDRSTS_I",
  "MI_I",
  "MI_MH",
  "PWDRNT2S_I",
  "DEFRNT2S_I",
  "DEFSEBCS_I",
  "PWDSCS_I",
  "LVJS_II",
  "PWDSEBCS_I",
  "LNT1S_II",
  "LNT2S_II",
  "GOBCS_VII",
  "DEFOBCS_VII",
  "LOBCS_II",
  "LOBCS_VII",
  "GSCS_VII",
  "LSCS_II",
  "GVJS_VII",
  "LVJS_VII",
  "LSCS_VII",
  "LOPENS_II",
  "DEFRVJS_I",
  "DEFSCS_VII",
  "LOPENS_VII",
  "DEFRNT3S_I",
  "PWDRVJS_I",
  "PWDSCS_VII",
  "PWDRNT1S_I",
  "PWDRNT3S_I",
  "DEFSTS_I",
  "PWDSTS_I-Non PWD",
  "PWDOBCS_VII"
]